// extracted by mini-css-extract-plugin
export var InputModule = "Input-module--InputModule--19H47";
export var SearchIcon = "Input-module--SearchIcon--1c6eS";